import React from "react";
import PartnerManagement from "../partner-management/PartnerManagement";
import { SUPPLIER_ENTITY } from "../partner-management/partnerEntityConfig";

/** Supplier Management — same screen, table, form and flow as Partner Management. */
const SupplierManagement = () => <PartnerManagement entity={SUPPLIER_ENTITY} />;

export default SupplierManagement;